export { default } from './TextReviewCard';
